import { TagInfo, token } from '@ferreri/prever-component-lib';
import { RuleTooltip } from './RuleTooltip';
import styled from '@emotion/styled';
import { KINSHIP_ADDITIONAL_DEPENDENT } from './constants';

type DependentLimitInfoProps = {
  slug: string;
  maxQuantity: number | null;
  maxQuantityAdditional: number | null;
  hasAdditionalDependentGlobal?: boolean;
};

export const DependentLimitInfo = (props: DependentLimitInfoProps) => {
  const isUnlimited = !props.maxQuantity || props.maxQuantity === 0;
  const isUnlimitedMaxQuantityAdditional =
    !props.maxQuantityAdditional || props.maxQuantityAdditional === 0;

  if (props.slug === KINSHIP_ADDITIONAL_DEPENDENT.slug) {
    return (
      <TagInfo>
        {isUnlimitedMaxQuantityAdditional
          ? 'ilimitado'
          : `até ${props.maxQuantityAdditional}`}
      </TagInfo>
    );
  }

  return (
    <InfoContent>
      <TagInfo>
        {isUnlimited ? 'ilimitado' : `até ${props.maxQuantity}`}
      </TagInfo>
      {!isUnlimited && (
        <RuleTooltip
          max_quantity={props.maxQuantity}
          hasAdditionalDependentGlobal={props.hasAdditionalDependentGlobal}
        />
      )}
    </InfoContent>
  );
};

const InfoContent = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxSmall};
  align-items: center;
  justify-content: center;
`;
